import React from 'react';
import { Card } from 'primereact/card';

export function NoDataPanel({ setShowInsert }) {
    return <Card className='my-5 w-full text-center surface-100'>
        Nessun elemento presente
    </Card>;
}
